import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Flex,
  Text,
  Tooltip,
} from "@fluentui/react-northstar";
import { withTranslation } from "react-i18next";
import {
  CloseIcon,
} from "@fluentui/react-icons-northstar";
import userSvg from "../../Assets/images/svg/user.svg";
import "./index.scss";
import StudentProgressCard from "../../pages/Charts/Reports/StudentProgress/StudentProgressCard/StudentProgressCard";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";


const StudentProgress = ({ user, triggerButton, headerText, t }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth > 767 && window.innerWidth <= 991
  );
  const [isTabletOrMobileView, setIsTabletOrMobileView] = useState(
    window.innerWidth <= 991
  );
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isMyProgressModalOpen, setIsMyProgressModalOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  const translation = t("studentProgress");

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
      setIsTabletView(window.innerWidth > 767 && window.innerWidth <= 991);
      setIsTabletOrMobileView(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleSelectStudent = (student) => {
    const student_ = {
      header: student?.StudentName || student.StudentEmailId.split("@")[0],
      image: student?.StudentPhoto?.Foto ? student.StudentPhoto.Foto +
        process.env.REACT_APP_AZURE_SAS_TOKEN.replace(/"/g, "")
        : userSvg,
      content: student,
      key: student.StudentEmailId,
    };

    setSelectedStudent(student_);
  };

  const myProgressBtnHandler = (student) => {
    setIsMyProgressModalOpen(true);
    handleSelectStudent(student)
  };


  return (
    <>
      <Dialog
        className={`student-progress-dialog ${isFullScreen ? "full-screen-dialog" : ""}`}
        open={isMyProgressModalOpen}
        confirmButton={t("setting").init[3]}
        onConfirm={() => {
          setIsMyProgressModalOpen(false);
        }}
        // header={<Text content={headerText} className="Karla fw6 m1" />}
        header={
          <Box>
            <Flex space="between" vAlign="center">
              <Text content={headerText} className="Karla fw6 m1" weight="semibold" />
              <Tooltip
                content={isFullScreen ? "Exit Full Screen" : "Full Screen"}
                styles={{
                  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
                }}
                trigger={
                  <Button
                    text
                    iconOnly
                    icon={
                      isFullScreen ? (
                        <FullscreenExitOutlined style={{ fontSize: "14px" }} />
                      ) : (
                        <FullscreenOutlined style={{ fontSize: "14px" }} />
                      )
                    }
                    onClick={() => setIsFullScreen(!isFullScreen)}
                    styles={{
                      height: "fit-content",
                    }}
                    aria-label={
                      isFullScreen ? "Exit Full Screen" : "Full Screen"
                    }
                  />
                }
                zIndex={10}
                mountNode={
                  document.getElementsByClassName("student-progress-dialog")[0]
                }
              />
            </Flex>
          </Box>
        }

        content={
          <StudentProgressCard
            user={user}
            isTabletOrMobileView={isTabletOrMobileView}
            isMobileView={isMobileView}
            isTabletView={isTabletView}
            selectedStudent={selectedStudent}
          />
        }
        trigger={triggerButton((email) => myProgressBtnHandler(email))}
        headerAction={{
          icon: <CloseIcon />,
          title: translation.common.close,
          onClick: () => {
            setIsMyProgressModalOpen(false);
          },
        }}
      />
    </>
  );
};

export default withTranslation()(StudentProgress);
